// cSpell:enableCompoundWords
import { SqGameID } from 'types/SqGame.types';

export const SqRoutes = {
  Home: '/',
  Login: '/login',
  Register: '/register',
  ForgotPassword: '/resetpassword',
  Logout: '/logout',
  Anonymous: '/anonymous',
  Lobby: '/lobby',
  Join: 'join',
  Resume: 'resume',
  CreateGame: 'creategame',
  Completed: 'completed',
  Game: '/game/:gameId',
  User: '/users/:userUid',

  getGameRoute: (gameId: SqGameID) => SqRoutes.Game.replace(':gameId', gameId),
  getUserRoute: (userUid: string) => SqRoutes.User.replace(':userUid', userUid),
};
